import { AxiosError } from "axios";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { endLoading, startLoading } from "../store/loader.slice";
import useError from "./useError";

const useLoader = (
  isLoading: boolean,
  errors?: (AxiosError|undefined)[],
  errorOptions?: any[],
) => {
  const dispatch = useDispatch();

  if (errors) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useError(errors, errorOptions);
  }

  useEffect(() => {
    if (isLoading) {
      dispatch(startLoading());
    } else {
      dispatch(endLoading());
    }
  }, [dispatch, isLoading]);
};

export default useLoader;